import React, { Fragment } from 'react';

import LifecycleProgress from 'app/developer-v3/components/SidebarRight/common/LifecycleProgress';
import {
  LifecycleJobStep,
  LifecycleStage,
} from 'app/entities/VersionLifecycle/types';

import Description from '../Description';

type Props = {
  currentStep: LifecycleJobStep;
  progress: number;
  stage: LifecycleStage;
};

function Progress({ progress, currentStep, stage }: Props) {
  return (
    <Fragment>
      <Description>
        We are running a number of tasks to migrate your user(s)' Zaps. This may
        take a while if your integration is used in a larger number of Zaps. You
        can follow the Zap migration progress below.
      </Description>
      <LifecycleProgress
        currentStep={currentStep}
        progress={progress}
        stage={stage}
      />
    </Fragment>
  );
}

export default Progress;
